import $http from '../../../../service/ajax';
import { getUrlParam } from '../../../../js/utils';

export function getTypeList() {
  return $http.post(
    '/FrankManager/geoProperty/getList.do',
    {
      ver: '1.0',
      data: {
        type: 5
      }
    }
  );
}

export function getPropertyList() {
  return $http.post(
    '/FrankManager/geoProperty/getPropertyList.do',
    {
      ver: '1.0',
      data: {
        type: 3
      }
    }
  );
}

export function getSerial(params) {
  return $http.post(
    '/FrankManager/geom/getGeoByParkingnoOrSerial.do',
    {
      ver: '1.0',
      data: params
    }
  );
}

export function submitSerialData(params) {
  return $http.post(
    `/FrankManager/geoActivate/saveOperate?UID=${getUrlParam('UID')}`,
    {
      ver: '1.0',
      data: params
    }
  );
}

// 查询车位地磁是否有更换
export function selectGeoReplace(params) {
  // return Promise.resolve({
  //   ver: '1.0',
  //   errno: '406',
  //   data: '1234567890', // 返回数据
  //   errtext: '406: 正在使用'
  // });
  return $http.post(
    '/FrankManager/geoActivate/selectGeoReplace',
    {
      ver: '1.0',
      data: params
    }
  );
}
